<template>
  <div class="dk-page-wrap">

    <!-- Painel Esquerdo -->
    <div class="dk-sidebar-panel">
      <div class="dk-panel-header">
        <div class="dk-icon-wrap" style="background: rgba(232,106,16,0.12);">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <rect x="3" y="3" width="18" height="18" rx="3" stroke="#E86A10" stroke-width="2"/>
            <path d="M3 9h18M9 21V9" stroke="#E86A10" stroke-width="2"/>
          </svg>
        </div>
        <div>
          <div class="dk-panel-title">Thumbnails</div>
          <div class="dk-panel-sub">Imagens de início, pausa e final</div>
        </div>
      </div>

      <div class="dk-panel-actions">
        <button class="dk-btn-primary" @click="salvar()">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" stroke="#fff" stroke-width="2"/><path d="M17 21v-8H7v8M7 3v5h8" stroke="#fff" stroke-width="2"/></svg>
          Salvar
        </button>
        <router-link :to="`/player/${vslId}/customizacao`" class="dk-btn-ghost">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M19 12H5M12 19l-7-7 7-7" stroke="#64748b" stroke-width="2" stroke-linecap="round"/></svg>
          Voltar
        </router-link>
      </div>

      <div class="dk-panel-body">
        <form>
          <!-- Thumbnail Início -->
          <div class="dk-thumb-section">
            <div class="dk-thumb-label">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#E86A10" stroke-width="2"/><path d="M10 8l6 4-6 4V8z" fill="#E86A10"/></svg>
              Thumbnail de Início
            </div>
            <label class="dk-upload-zone" for="picture__input" tabIndex="0">
              <span class="picture__image dk-upload-placeholder">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12" stroke="#94a3b8" stroke-width="2" stroke-linecap="round"/></svg>
                <span>Clique para enviar</span>
              </span>
              <input id="picture__input" type="file" name="picture__input" class="dk-file-input" @change="uploadImageUrl($event, 'picture__image')">
              <img v-if="imageUrlInicio" :src="imageUrlInicio" class="dk-thumb-preview">
            </label>
            <div v-if="valid == true" class="dk-thumb-delete">
              <button type="button" class="dk-btn-danger" @click="deletarAWS(Thumb[0].tumb_key_name_start); DeletThumb()">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M3 6h18M19 6l-1 14H6L5 6M10 11v6M14 11v6M9 6V4h6v2" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>
                Deletar
              </button>
            </div>
          </div>

          <div class="dk-divider" />

          <!-- Thumbnail Pause -->
          <div class="dk-thumb-section">
            <div class="dk-thumb-label">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><rect x="6" y="4" width="4" height="16" rx="1" fill="#E86A10"/><rect x="14" y="4" width="4" height="16" rx="1" fill="#E86A10"/></svg>
              Thumbnail de Pausa
            </div>
            <label class="dk-upload-zone" for="Input_UploadPausa" tabIndex="0">
              <span class="picture__imageUpload dk-upload-placeholder">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12" stroke="#94a3b8" stroke-width="2" stroke-linecap="round"/></svg>
                <span>Clique para enviar</span>
              </span>
              <input id="Input_UploadPausa" ref="upload" type="file" name="Input_UploadPausa" class="dk-file-input" @change="uploadImageUrl($event, 'picture__imageUpload')">
              <img v-if="imageUrlPausa" :src="imageUrlPausa" class="dk-thumb-preview">
            </label>
            <div v-if="validPausa == true" class="dk-thumb-delete">
              <button type="button" class="dk-btn-danger" @click="deletarAWSPausa(Thumb[0].thumb_key_name_pausa); DeletThumbPausa()">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M3 6h18M19 6l-1 14H6L5 6M10 11v6M14 11v6M9 6V4h6v2" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>
                Deletar
              </button>
            </div>
          </div>

          <div class="dk-divider" />

          <!-- Thumbnail Final -->
          <div class="dk-thumb-section">
            <div class="dk-thumb-label">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M5 4l15 8-15 8V4z" fill="#E86A10"/></svg>
              Thumbnail de Final
            </div>
            <label class="dk-upload-zone" for="Input_UploadFinal" tabIndex="0">
              <span class="pictureFinal dk-upload-placeholder">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12" stroke="#94a3b8" stroke-width="2" stroke-linecap="round"/></svg>
                <span>Clique para enviar</span>
              </span>
              <input id="Input_UploadFinal" ref="upload" type="file" name="Input_UploadFinal" class="dk-file-input" @change="uploadImageUrl($event, 'pictureFinal')">
              <img v-if="imageUrlEnd" :src="imageUrlEnd" class="dk-thumb-preview">
            </label>
            <div v-if="validFinal == true" class="dk-thumb-delete">
              <button type="button" class="dk-btn-danger" @click="deletarAWSFinal(Thumb[0].thumb_key_name_end); DeletThumbFinal()">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M3 6h18M19 6l-1 14H6L5 6M10 11v6M14 11v6M9 6V4h6v2" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>
                Deletar
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Player Preview -->
    <div class="dk-player-area">
      <div class="dk-player-label">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#E86A10" stroke-width="2"/><path d="M10 8l6 4-6 4V8z" fill="#E86A10"/></svg>
        Preview do Player
      </div>
      <div class="dk-thumb-tabs">
        <button
          v-for="tab in thumbTabs"
          :key="tab.key"
          class="dk-thumb-tab"
          :class="{ active: activeThumbTab === tab.key }"
          @click="activeThumbTab = tab.key"
        >{{ tab.label }}</button>
      </div>
      <player-preview-iframe
        :vsl-id="vslId"
        :thumb-src="activeThumbSrc"
        :key="activeThumbTab + '_' + activeThumbSrc"
        :orientation="dadosVideo && dadosVideo.orientation ? dadosVideo.orientation : 'Horizontal'"
      />
    </div>

  </div>
</template>

<script>

import axios from 'axios'
import { ThumbNailsService } from '@/services/Thumbnails'
import { ControlsService } from '@/services/Controls'
import Detalhes from '../../EditarVideo/Detalhes.vue'
import PlayerPreviewIframe from '@/components/player/PlayerPreviewIframe.vue'

export default {
  components: {
    Detalhes,
    PlayerPreviewIframe,
  },
  data() {
    return {
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND || '/api/dkbackend',
      VUE_APP_HOST_API_AWS_S3: process.env.VUE_APP_HOST_API_AWS_S3 || '/api/dkbucket',
      userData: JSON.parse(localStorage.getItem('userData')),
      vslId: this.$route.params.vslId,
      errorMessage: null,
      loading: false,

      valid: '',
      validPausa: '',
      validFinal: '',

      imageUrlInicio: '',
      imageUrlPausa: '',
      imageUrlEnd: '',

      dialogImageUrl: '',
      dialogVisible: false,

      uploadPercentage: 0,

      urlImagem: '',
      key_name: '',
      urlImagemPausa: '',
      key_namePausa: '',
      urlImagemFinal: '',
      key_nameFinal: '',

      Thumb: [],
      files: [],
      filesPausa: [],
      filesFinal: [],
      playx: 'true',

      control: [],
      dadosVideo: [],

      activeThumbTab: 'inicio',
      thumbTabs: [
        { key: 'inicio', label: 'Início' },
        { key: 'pausa', label: 'Pausa' },
        { key: 'final', label: 'Final' },
      ],
    }
  },
  computed: {
    getControls() {
      return this.control
    },
    getVideoSetting() {
      return this.dadosVideo
    },
    activeThumbSrc() {
      if (this.activeThumbTab === 'inicio') return this.imageUrlInicio || ''
      if (this.activeThumbTab === 'pausa') return this.imageUrlPausa || ''
      if (this.activeThumbTab === 'final') return this.imageUrlEnd || ''
      return ''
    },
  },

  mounted() {
    this.listar()

    this.UploadImgFinal()
    this.UploadImgPausa()
    this.UploadImg()
  },

  async created() {
    try {
      const response = await ThumbNailsService.getALLThumbnails()
      this.Thumb = response.data
      const controle = await ControlsService.getControlVSL_Id(this.vslId)
      console.log(this.vslId)
      this.control = controle.data
      this.loading = false
    } catch (error) {
      this.errorMessage = error
      this.loading = false
    }
  },
  beforeMount() {
    this.jsonPersonalizado()
  },
  methods: {
    formatTime(time) {
      // Pega os segundos, minutos e horas
      let seconds = Math.floor(time % 60)
      let minutes = Math.floor(time / 60) % 60
      let hours = Math.floor(time / 3600)

      // adiciona 0 antes do numero se o for menor que 10;
      seconds = seconds < 10 ? `0${seconds}` : seconds
      minutes = minutes < 10 ? `0${minutes}` : minutes
      hours = hours < 10 ? `0${hours}` : hours

      if (hours == 0) {
        return `${minutes}:${seconds}`
      }
      return `${hours}:${minutes}:${seconds}`
    },
    jsonPersonalizado() {
      const url = `${this.VUE_APP_HOST_API_BACKEND}/vslsInner/${this.vslId}`
      fetch(url)
        .then(response => response.json())
        .then(data => {
          if (data.status == '1') {
            this.dadosVideo = data.json.find(item => String(item.id) === String(this.vslId))
            console.log(this.dadosVideo)
          }
        })
    },
    togglePlay() {
      const player = document.querySelector('.player')
      const video = player.querySelector('.player_my_video')
      const togglePausePlay = player.querySelector('.playpause')
      const togglePausePlaybg = player.querySelector('.playpausebg')
      const toggleEndedbg = player.querySelector('.playEndedbg')
      const iniciar = player.querySelector('.iniciar')

      if (video.ended) {
        console.log('PRIMEIRO')
        toggleEndedbg.setAttribute('hidden', '')
        console.log('togglePausePlay')
      }
      if (video.paused) {
        console.log('PRIMEIRO2')
        video.play()

        togglePausePlay.setAttribute('hidden', '')
        togglePausePlaybg.setAttribute('hidden', '')

        video.muted = false
      } else if (this.playx == 'true') {
        ('Caiu aqui')
        iniciar.style.visibility = 'hidden'
        video.muted = false
        video.load()
        this.playx = false
      } else {
        video.pause()

        console.log('pausado')
        togglePausePlay.removeAttribute('hidden')
        togglePausePlaybg.removeAttribute('hidden')
      }
    },
    avancar() {
      const player = document.querySelector('.player')
      const video = player.querySelector('.player_my_video')
      video.currentTime += 10
    },

    retroceder() {
      const player = document.querySelector('.player')
      const video = player.querySelector('.player_my_video')
      video.currentTime -= 10
    },
    toggleFullScreen() {
      const player = document.querySelector('.player')

      if (!document.fullscreenElement && !document.mozFullScreenElement
        && !document.webkitFullScreenElement && !document.msFullScreenElement) {
        if (player.requestFullscreen) {
          player.requestFullscreen()
        } else if (player.msRequestFullscreen) {
          player.msRequestFullScreen()
        } else if (player.mozRequestFullScreen) {
          player.mozRequestFullScreen()
        } else if (player.webkitRequestFullscreen) {
          player.webkitRequestFullscreen()
        } else if (player.webkitRequestFullscreen) {
          player.webkitRequestFullscreen()
        }
      } else if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      }
    },

    updateButton() {
      const player = document.querySelector('.player')
      const toggle = player.querySelector('.toggle')
      const icon = this.paused ? '▶' : '❚❚'
      console.log(icon)
      toggle.textContent = icon
      console.log('mudei')
    },
    handleProgress(e) {
      var percentReal; let
        percentFake
      const player = document.querySelector('.player')
      const video = player.querySelector('.player_my_video')

      const progressBar = player.querySelector('.progress_my_filled')
      const togglePausePlay = player.querySelector('.playpause')
      const toggleEndedbg = player.querySelector('.playEndedbg')

      const { currentTime, duration } = e.target // pegar o time atual e a duração
      const percent = (currentTime / duration) * 100 // pega o percentual
      progressBar.style.width = `${percent}%` // passa a porcentagem para o WIDTH do progresso
      console.log(this.formatTime(currentTime))

      if (video.ended) {
        toggleEndedbg.removeAttribute('hidden')
        togglePausePlay.removeAttribute('hidden')
        console.log('VIDEO FINALIZADO...', video.ended)
      }

      // let timelineWidth = this.$refs.mainVideo.clientWidth; // pega o videoTimeline width
      // progressBar.style.width = `${e.offsetX}px`; // passing offsetX value as progressbar width
      // this.$refs.mainVideo.currentTime = (e.offsetX / timelineWidth) * this.$refs.mainVideo.duration; // atualiza time atual do video

      percentFake = (video.currentTime / 150) * 100
      if (percentFake <= 50) {
        var percentReal = (video.currentTime / 150) * 100
        progressBar.style.flexBasis = `${percentFake}%`
      } else {
        //  console.log(video.duration);
        var percentReal = ((video.duration / 2) / video.duration) * 100
        progressBar.style.flexBasis = `${percentReal}%`
      }
    },

    salvar() {
      let algumEnvio = false
      if (this.files instanceof File) {
        algumEnvio = true
        this.enviarArquivo()
      }
      if (this.filesPausa instanceof File) {
        algumEnvio = true
        this.enviarArquivoPausa()
      }
      if (this.filesFinal instanceof File) {
        algumEnvio = true
        this.enviarArquivoFinal()
      }
      if (!algumEnvio) {
        this.$message({ type: 'info', message: 'Nenhuma imagem nova selecionada.' })
      }
    },

    listar() {
      ThumbNailsService.getThumbnailVSL_Id(this.vslId).then(resposta => {
        this.Thumb = resposta.data
        this.valid = (this.Thumb[0].tumb_start.length >= 1)
        this.validPausa = (this.Thumb[0].tumb_pausa.length >= 1)
        this.validFinal = (this.Thumb[0].tumb_end.length >= 1)

        this.imageUrlInicio = (this.Thumb[0].tumb_start)
        this.imageUrlPausa = (this.Thumb[0].tumb_pausa)
        this.imageUrlEnd = this.Thumb[0].tumb_end
      }).catch(e => {
        console.log(e)
      })
    },

    enviarArquivo() {
      const formData = new FormData()
      formData.append('video', this.files)
      formData.append('caminho', `${this.userData.user_file_key}UploadImageThumb/Thumbnail_inicio/`)
      axios.post(`${this.VUE_APP_HOST_API_AWS_S3}/thumb`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100))
          }.bind(this),
        })
        .then(response => {
          this.urlImagem = response.data.data.fileUrl
          this.NameImagem = response.data.data.fileNameOrigin
          this.key_name = response.data.data.key_filename
          if (response.data.data.status == 201) {
            this.updateSubmit()
          }
        })
        .catch(() => {
          console.log('FAILURE!!')
        })
    },
    enviarArquivoPausa() {
      const formData = new FormData()

      formData.append('video', this.filesPausa)
      formData.append('caminho', `${this.userData.user_file_key}UploadImageThumb/Thumbnail_Pause/`)

      axios.post(`${this.VUE_APP_HOST_API_AWS_S3}/thumb`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100))
          }.bind(this),
        })

        .then(response => {
          this.urlImagemPausa = response.data.data.fileUrl
          this.NameImagemPausa = response.data.data.fileNameOrigin
          this.key_namePausa = response.data.data.key_filename
          if (response.data.data.status == 201) {
            this.updateSubmitPausa()
          }
        })
        .catch(() => {
          console.log('FAILURE!!')
        })
    },
    enviarArquivoFinal() {
      const formData = new FormData()
      formData.append('video', this.filesFinal)
      formData.append('caminho', `${this.userData.user_file_key}UploadImageThumb/Thumbnail_Final/`)

      axios.post(`${this.VUE_APP_HOST_API_AWS_S3}/thumb`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100))
          }.bind(this),
        })

        .then(response => {
          this.urlImagemFinal = response.data.data.fileUrl
          this.NameImagemFinal = response.data.data.fileNameOrigin
          this.key_nameFinal = response.data.data.key_filename
          if (response.data.data.status == 201) {
            this.updateSubmitFinal()
          }
        })
        .catch(() => {
          console.log('FAILURE!!')
        })
    },

    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    uploadImageUrl(e, classImage) {
      const pictureImage = document.querySelector(`.${classImage}`)
      let currentFile = null

      if (classImage === 'picture__image') {
        this.files = e.target.files[0]
        currentFile = this.files
      }
      if (classImage === 'picture__imageUpload') {
        this.filesPausa = e.target.files[0]
        currentFile = this.filesPausa
      }
      if (classImage === 'pictureFinal') {
        this.filesFinal = e.target.files[0]
        currentFile = this.filesFinal
      }

      if (currentFile) {
        const reader = new FileReader()

        reader.addEventListener('load', e => {
          const readerTarget = e.target
          const img = document.createElement('img')

          if (classImage === 'picture__image') {
            this.imageUrlInicio = readerTarget.result
          }
          if (classImage === 'picture__imageUpload') {
            this.imageUrlPausa = readerTarget.result
          }
          if (classImage === 'pictureFinal') {
            this.imageUrlEnd = readerTarget.result
          }

          img.src = readerTarget.result
          img.classList.add('picture__img')
          img.setAttribute('style', 'max-width:100%; border-radius:8px; object-fit:cover;')
          if (pictureImage) {
            pictureImage.innerHTML = ''
            pictureImage.appendChild(img)
          }
        })

        reader.readAsDataURL(currentFile)
      }
    },
    UploadImg() {
      const inputFile = document.querySelector('#picture__input')
      const pictureImage = document.querySelector('.picture__image')
      const pictureImageTxt = ''
      pictureImage.innerHTML = pictureImageTxt

      inputFile.addEventListener('change', e => {
        const inputTarget = e.target
        console.log(inputTarget)
        const file = inputTarget.files[0]
        this.files = inputTarget.files[0]

        if (file) {
          const reader = new FileReader()

          reader.addEventListener('load', e => {
            const readerTarget = e.target

            const img = document.createElement('img')
            img.src = readerTarget.result
            img.setAttribute('style', 'max-width:100%;')
            img.classList.add('picture__img')

            pictureImage.innerHTML = ''
            pictureImage.appendChild(img)
          })

          reader.readAsDataURL(file)
        } else {
          pictureImage.innerHTML = pictureImageTxt
        }
      })
    },
    UploadImgPausa() {
      const inputFile = document.querySelector('#Input_UploadPausa')
      const pictureImage = document.querySelector('.picture__imageUpload')
      const pictureImageTxt = ''
      pictureImage.innerHTML = pictureImageTxt

      inputFile.addEventListener('change', e => {
        const inputTarget = e.target
        const file = inputTarget.files[0]
        this.filesPausa = inputTarget.files[0]
        if (file) {
          const reader = new FileReader()

          reader.addEventListener('load', e => {
            const readerTarget = e.target

            const img = document.createElement('img')
            img.src = readerTarget.result
            img.classList.add('picture__img')
            img.setAttribute('style', 'max-width:100%;')
            pictureImage.innerHTML = ''
            pictureImage.appendChild(img)
          })

          reader.readAsDataURL(file)
        } else {
          pictureImage.innerHTML = pictureImageTxt
        }
      })
    },
    UploadImgFinal() {
      const inputFile = document.querySelector('#Input_UploadFinal')
      const pictureImage = document.querySelector('.pictureFinal')
      const pictureImageTxt = ''
      pictureImage.innerHTML = pictureImageTxt

      inputFile.addEventListener('change', e => {
        const inputTarget = e.target
        const file = inputTarget.files[0]
        this.filesFinal = inputTarget.files[0]

        if (file) {
          const reader = new FileReader()

          reader.addEventListener('load', e => {
            const readerTarget = e.target

            const img = document.createElement('img')
            img.src = readerTarget.result
            img.classList.add('picture__img')
            img.setAttribute('style', 'max-width:100%;')
            pictureImage.innerHTML = ''
            pictureImage.appendChild(img)
          })

          reader.readAsDataURL(file)
        } else {
          pictureImage.innerHTML = pictureImageTxt
        }
      })
    },

    updateSubmit() {
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/tumbinicio/${this.vslId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: `{"tumb_start":"${this.urlImagem
        }","tumb_key_name_start":"${this.key_name
        }","id_vsl":"${this.vslId
        }"}`,
      })

        .then(response => {
          console.log(response)
          this.listar()
          this.$message({
            type: 'success',
            message: 'Salvo com sucesso',
          })
        })

        .catch(err => console.error(err))
    },
    updateSubmitPausa() {
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/tumbpausa/${this.vslId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: `{"tumb_pausa":"${this.urlImagemPausa
        }","thumb_key_name_pausa":"${this.key_namePausa
        }","id_vsl":"${this.vslId
        }"}`,
      })

        .then(response => {
          console.log(response)
          this.listar()
          this.$message({
            type: 'success',
            message: 'Salvo com sucesso',
          })
        })

        .catch(err => console.error(err))
    },
    updateSubmitFinal() {
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/tumbfinal/${this.vslId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: `{"tumb_end":"${this.urlImagemFinal
        }","thumb_key_name_end":"${this.key_nameFinal
        }","id_vsl":"${this.vslId
        }"}`,
      })

        .then(response => {
          console.log(response)
          this.$message({
            type: 'success',
            message: 'Salvo com sucesso',
          })
          this.listar()
        })
        .catch(err => console.error(err))
    },

    DeletThumb() {
      this.url = ''
      this.key = ''
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/tumbinicio/${this.vslId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: `{"tumb_start":"${this.url
        }","tumb_key_name_start":"${this.key
        }","id_vsl":"${this.vslId
        }"}`,
      })
        .then(response => {
          if (response.status == 200) {
            this.deletarAWS
            this.listar()
          }
        })

        .catch(err => console.error(err))
    },
    DeletThumbPausa() {
      this.url = ''
      this.key = ''
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/tumbpausa/${this.vslId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: `{"tumb_pausa":"${this.url
        }","thumb_key_name_pausa":"${this.key
        }","id_vsl":"${this.vslId
        }"}`,
      })

        .then(response => {
          if (response.status == 200) {
            this.deletarAWS
            this.listar()
          }
        })

        .catch(err => console.error(err))
    },
    DeletThumbFinal() {
      this.url = ''
      this.key = ''
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/tumbfinal/${this.vslId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: `{"tumb_end":"${this.url
        }","thumb_key_name_end":"${this.key
        }","id_vsl":"${this.vslId
        }"}`,
      })

        .then(response => {
          if (response.status == 200) {
            this.deletarAWSFinal()
            this.listar()
          }
        })

        .catch(err => console.error(err))
    },

    deletarAWS(Thumb) {
      console.log('Thumb')
      console.log(Thumb)

      const options = {
        method: 'DELETE',
        url: `${this.VUE_APP_HOST_API_AWS_S3}/`,
        params: {
          key: Thumb,
          delete: '',
        },
      }
      axios.request(options).then(function (response) {
        this.listar()
      }).catch(error => {
        console.error(error)
      })
    },
    deletarAWSPausa(Thumb) {
      console.log('Thumb')
      console.log(Thumb)
      const options = {
        method: 'DELETE',
        url: `${this.VUE_APP_HOST_API_AWS_S3}/`,
        params: {
          key: Thumb,
          delete: '',
        },
      }

      axios.request(options).then(response => {

      }).catch(error => {
        console.error(error)
      })
    },
    deletarAWSFinal(Thumb) {
      console.log('Thumb')
      console.log(Thumb)
      const options = {
        method: 'DELETE',
        url: `${this.VUE_APP_HOST_API_AWS_S3}/`,
        params: {
          key: Thumb,
          delete: '',
        },
      }

      axios.request(options).then(response => {
        // console.log('responsedeleteaws')
        // console.log(response)
        // document.location.reload(true);
      }).catch(error => {
        console.error(error)
      })
    },

  },

}

</script>
<style lang="scss" scoped>
@import '@/assets/scssThumbnails/thumbInicio.scss';
@import '@/assets/scssThumbnails/thumbPausa.scss';
@import '@/assets/scssThumbnails/thumFinal.scss';

.tb {
  display: inline-block;
  width: 30px;
  height: 30px;
  margin: 0px;
  border: none;
}

.picture {
  width: 100%;
}

.image_src {
  max-width: 100%;
}

.player {
  max-width: 900px;
  /* //border: 4px solid rgba(0,0,0,.2);
 //box-shadow: 0 0 20px rgba(0,0,0,.2); */
  position: relative;
  font-size: 20;
  overflow: hidden;
}

.player {
  width: 100%;
  height: 500px;
}

.player:fullcreen {
  max-width: none;
  width: 100%;
}

.player:-webkit-full-screen {
  max-width: none;
  width: 100%;
}

.player:-ms-full-screen {
  max-width: none;
  width: 100%;
}

.player:-moz-full-screen {
  max-width: none;
  width: 100%;
}

.player_my_video {
  min-width: 102%;
  height: 500px;
}

.player_my_controls {
  display: flex;
  position: absolute;
  bottom: 0;
  width: 97%;
  transform: translateY(100%) translateY(-31%);
  transition: all .3s;
  flex-wrap: wrap;
  background: rgba(0, 0, 0, .2);
}

.progress_my_filled {
  width: 80%;
  /* //background: #ffc600; */
  background: rgba(255, 226, 40, 0.815);
  flex: 0;
  flex-basis: 0%;
}

.player:hover .player_my_controls {
  transform: translateY(0);
}

.player_my_controls>* {
  flex: 1;
}

.progress {
  flex: 10;
  position: relative;
  display: flex;
  flex-basis: 100%;
  height: 10px;
  transition: height .3s;
  background: rgba(0, 0, 0, .25);
  cursor: pointer;
  /* ew-resize*/
}

.player_my_button {
  background: none;
  border: 0;
  line-height: 1;
  color: white;
  text-align: center;
  outline: 0;
  padding: 10px 15px 10px 15px;
  cursor: pointer;
  max-width: 50px;

}

.playerSlider {
  display: block;
  width: 10px;
  height: 30px;
}

input[type=range] {
  -webkit-appearance: none !important;
  background: transparent;
  width: 100%;
  margin: 0 5px;
}

input[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  height: 2px;
  cursor: pointer;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0 0 1px rgba(13, 13, 13, 0);
  background: rgba(255, 255, 255, .8);
  border-radius: 1.3px;
  border: 0.2px solid rgba(1, 1, 1, 0)
}

input[type=range]::-webkit-slider-thumb {
  height: 10px;
  width: 10px;
  border-radius: 50px;
  background: var(--dk-bg-card, #fff);
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -4px;
  box-shadow: 0 0 2px rgba(0, 0, 0, .2);
}

input[type=range]:focus {
  outline: none;

}

input[type=range]:focus::-webkit-slider-runnable-track {
  background: #ff0;

}

/* Mozila Linha do volume*/

input[type=range]::-moz-range-track {
  width: 100%;
  height: 0.1px;
  cursor: pointer;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0 0 1px rgba(13, 13, 13, 0);
  background: var(--dk-bg-card, #fff);
  border-radius: 1.3px;
  border: 0.2px solid rgba(1, 1, 1, 0)
}

/* Mozila Circulo do volume*/

input[type=range]::-moz-range-thumb {
  height: 10px;
  width: 10px;
  border-radius: 50px;
  border-color: none;
  background: var(--dk-bg-card, #fff);
  cursor: pointer;
}

.fullscreenbtn {

  margin-left: 75%;
  border: 0;
  line-height: 1;
  color: white;
  text-align: center;
  align-content: stretch;
  outline: 0;
  cursor: pointer;
  max-width: 4px;
}

.button_volume {

  margin-left: -2%;
  border: 0;
  line-height: 1;
  color: white;
  text-align: center;
  align-content: stretch;
  outline: 0;
  cursor: pointer;
  max-width: 4px;
}

.PictureInPicture {
  margin-left: -9%;
  border: 0;
  line-height: 1;
  color: white;
  text-align: center;
  align-content: stretch;
  outline: 0;
  cursor: pointer;
  max-width: 4px;
}

.playpause {

  border-radius: 50px;
  background-image: url(../img/play.svg);
  background-repeat: no-repeat;
  width: 100px;
  height: 100px;
  position: absolute;
  left: 0%;
  right: 0%;
  top: 0%;
  bottom: 0%;
  margin: auto;
  background-size: contain;
  background-position: center;
  cursor: pointer;
  z-index: 10 !important;
}

.playpause {
  opacity: 1;
  transition: opacity 400ms;
}

.playpause[hidden] {
  opacity: 0;

}

.iniciar {
  border: 2px solid;
  border-style: none;
  border-radius: 15px 50px;
  display: block;
  width: 50%;
  height: 50%;
  position: absolute;
  flex-direction: column-reverse;
  display: flex;
  left: 0%;
  right: 0%;
  top: 0%;
  bottom: 0%;
  margin: auto;
  align-items: center;
  background-size: contain;
  background-position: center;

}

.video-banner {
  position: relative;
}

.video-banner .overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  z-index: 1;
}

.loader {
  height: 70px;
  width: 200px;
  display: flex;
  align-items: center;
}

.loader .stroke {
  display: block;
  position: relative;
  background: var(--dk-bg-inset, #f1f1f1);
  height: 50%;
  width: 15%;
  border-radius: 50px;
  margin: 0 5px;
  align-items: center;
  animation: animate 1.2s linear infinite;
}

/* .playImagem {
    width: 64px;
    height: 64px;
    cursor: pointer;
  } */

h2 {
  position: relative;
  align-self: center;
  font-family: Arial, Helvetica, sans-serif;
}

@keyframes animate {
  50% {
    height: 20%;
  }

  100% {
    height: 100%;
  }
}

.stroke:nth-child(1) {
  animation-delay: 0s;
}

.stroke:nth-child(2) {
  animation-delay: 0.3s;
}

.stroke:nth-child(3) {
  animation-delay: 0.6s;
}

.stroke:nth-child(4) {
  animation-delay: 0.9s;
}

.stroke:nth-child(5) {
  animation-delay: 0.6s;
}

.stroke:nth-child(6) {
  animation-delay: 0;
}

.stroke:nth-child(7) {
  animation-delay: 0.2s;
}

.stroke:nth-child(8) {
  animation-delay: 0.5s;
}

.stroke:nth-child(9) {
  animation-delay: 0.1s;
}

.stroke:nth-child(10) {
  animation-delay: 0s;
}

.stroke:nth-child(11) {
  animation-delay: 0.3s;
}

.stroke:nth-child(12) {
  animation-delay: 0.6s;
}

.stroke:nth-child(13) {
  animation-delay: 0.3s;
}

#context-menu {
  position: fixed;
  width: 170px;
  height: 20px;
  border: #000;
  background: rgba(40, 38, 38, 0.856);
  transform: scale(0);
  transform-origin: top left;
  padding: 8px 8px 8px 8px;
}

#context-menu.active {
  transform: scale(1);
  transition: transform 200ms ease-in-out;
}

#context-menu a {
  font-size: 15px;
  font-family: Arial, Helvetica, sans-serif;
  color: #eee;
  text-decoration: none;
}

#context-menu .item:hover {
  background: #555;
}

.playpausebg {
  height: 100%;
  background-size: cover;

  background-repeat: no-repeat;
  width: 102%;
  height: 128%;
  position: absolute;
  left: 0%;
  right: 0%;
  top: 0%;
  bottom: 0%;
  margin: auto;
  background-position: center;
  cursor: pointer;
  z-index: 2 !important;
}

.playpausebg {
  opacity: 1;
  transition: opacity 400ms;
}

.playpausebg[hidden] {
  opacity: 0;

}

.playEndedbg {

  background-repeat: no-repeat;
  width: 100%;
  position: absolute;
  left: 0%;
  right: 0%;
  top: 0%;
  bottom: 0%;
  margin: auto;
  background-position: center;
  cursor: pointer;
  z-index: 2 !important;
  height: 100%;
  background-size: cover;
}

.playEndedbg {
  opacity: 1;
  transition: opacity 400ms;
}

.playEndedbg[hidden] {
  opacity: 0;
}

/* ===================== DK UPLOAD STYLES ===================== */
.dk-thumb-section {
  margin-bottom: 4px;
}
.dk-thumb-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 700;
  color: var(--dk-text-primary, #0D3349);
  margin-bottom: 10px;
}
.dk-upload-zone {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100px;
  border: 2px dashed var(--dk-border, #DDE3EA);
  border-radius: 10px;
  background: var(--dk-bg-page, #F8FAFB);
  cursor: pointer;
  overflow: hidden;
  position: relative;
  transition: border-color 0.18s, background 0.18s;
}
.dk-upload-zone:hover {
  border-color: #E86A10;
  background: rgba(232,106,16,0.04);
}
.dk-upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: var(--dk-text-muted, #94a3b8);
  font-size: 12px;
  font-weight: 500;
  padding: 16px;
  width: 100%;
  min-height: 96px;
}
.dk-upload-placeholder span {
  color: var(--dk-text-muted, #94a3b8);
}
.dk-file-input {
  display: none !important;
}
.dk-thumb-preview {
  max-width: 100%;
  max-height: 140px;
  border-radius: 8px;
  object-fit: cover;
  display: block;
}
.dk-thumb-delete {
  margin-top: 8px;
  display: flex;
  justify-content: flex-end;
}
.dk-btn-danger {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: #ef4444 !important;
  background-image: none !important;
  color: #fff !important;
  border: none;
  border-radius: 7px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}
.dk-btn-danger:hover { background: #dc2626 !important; }
/* When image is uploaded, the span becomes a container for the img tag */
.picture__image img,
.picture__imageUpload img,
.pictureFinal img {
  max-width: 100%;
  max-height: 140px;
  border-radius: 8px;
  object-fit: cover;
  display: block;
}
.picture__image,
.picture__imageUpload,
.pictureFinal {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 96px;
}

/* ===================== DK BRAND STYLES ===================== */
.dk-page-wrap {
  display: flex; flex-direction: row;
  min-height: calc(100vh - 80px); background: var(--dk-bg-segment, #F4F6F9);
  --dk-bg-segment:     rgba(255,255,255,0.04);
  --dk-bg-card:        rgba(255,255,255,0.05);
  --dk-bg-page:        rgba(255,255,255,0.04);
  --dk-border:         rgba(255,255,255,0.09);
  --dk-border-light:   rgba(255,255,255,0.07);
  --dk-text-primary:   #e2e8f0;
  --dk-text-secondary: rgba(255,255,255,0.6);
  --dk-text-muted:     rgba(255,255,255,0.4);
  --dk-text-faint:     rgba(255,255,255,0.25);
}
.dk-sidebar-panel {
  width: 300px; min-width: 280px; max-width: 310px;
  background: var(--dk-bg-card, #fff); border-right: 1px solid rgba(255,255,255,0.09);
  display: flex; flex-direction: column; overflow-y: auto;
}
.dk-panel-header {
  display: flex; align-items: center; gap: 12px;
  padding: 24px 20px 16px; border-bottom: 1px solid var(--dk-border-light, #F0F2F5);
}
.dk-icon-wrap {
  width: 40px; height: 40px; border-radius: 10px;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.dk-panel-title { font-size: 15px; font-weight: 700; color: var(--dk-text-primary, #0D3349); }
.dk-panel-sub { font-size: 11px; color: var(--dk-text-muted, #94a3b8); margin-top: 2px; }
.dk-panel-actions {
  display: flex; gap: 8px; padding: 14px 20px;
  border-bottom: 1px solid var(--dk-border-light, #F0F2F5);
}
.dk-panel-body { padding: 20px; flex: 1; overflow-y: auto; }
.dk-btn-primary {
  display: inline-flex; align-items: center; gap: 6px;
  background: #E86A10 !important; background-image: none !important;
  color: #fff !important; border: none; border-radius: 8px;
  padding: 9px 18px; font-size: 13px; font-weight: 600;
  cursor: pointer; box-shadow: 0 2px 8px rgba(232,106,16,0.25);
}
.dk-btn-primary:hover { background: #cf5c07 !important; }
.dk-btn-ghost {
  display: inline-flex; align-items: center; gap: 6px;
  background: var(--dk-bg-segment, #F4F6F9) !important; background-image: none !important;
  color: var(--dk-text-secondary, #64748b) !important; border: 1px solid rgba(255,255,255,0.09);
  border-radius: 8px; padding: 9px 16px; font-size: 13px;
  font-weight: 500; cursor: pointer; text-decoration: none;
}
.dk-btn-ghost:hover { background: rgba(255,255,255,0.08) !important; text-decoration: none; }
.dk-divider { border-top: 1px solid var(--dk-border-light, #F0F2F5); margin: 16px 0; }
.dk-section-title {
  font-size: 11px; font-weight: 700; text-transform: uppercase;
  letter-spacing: 0.08em; color: var(--dk-text-muted, #94a3b8); margin-bottom: 10px;
}
.dk-player-area {
  flex: 1; display: flex; flex-direction: column;
  padding: 32px 40px; background: var(--dk-bg-segment, #F4F6F9); min-width: 0;
}
.dk-player-label {
  display: flex; align-items: center; gap: 6px;
  font-size: 11px; font-weight: 700; text-transform: uppercase;
  letter-spacing: 0.08em; color: var(--dk-text-muted, #94a3b8); margin-bottom: 10px;
}
.dk-thumb-tabs {
  display: flex; gap: 6px; margin-bottom: 14px;
}
.dk-thumb-tab {
  padding: 5px 16px; border-radius: 20px; border: 1.5px solid var(--dk-border, #DDE3EA);
  background: var(--dk-bg-card, #fff); color: var(--dk-text-secondary, #64748b); font-size: 12px; font-weight: 600;
  cursor: pointer; transition: all 0.15s;
}
.dk-thumb-tab:hover { border-color: #E86A10; color: #E86A10; }
.dk-thumb-tab.active {
  background: #E86A10; border-color: #E86A10; color: #fff;
}
</style>
